import {
	AlertInfo,
	BeneficiaryCard,
	ErrorState,
	MainFooter,
	MainHeader,
	PageWrapperLayout,
	StyledGrid,
} from 'presentation/components';
import {AuthorizationsEnum, FeaturesEnum} from 'presentation/constants';
import {translations} from 'presentation/translations-new';
import React, {Fragment, useCallback} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {Attachments, LoadingState, Messages, RequestInfoDetailCard} from '../../components';
import {AuthorizationStatusEnum, statusMap} from '../../constants';
import {StyledFooterContainer} from '../../styles';
import {
	StyledAlertTitle,
	StyledBoxAlertInfo,
	StyledGridItem,
	StyledRootGrid,
	StyledStack,
} from './styles';
import {DialogFinished} from '../../components/DialogFinished';
import {useGetAuthDetail} from '../../queries/useGetAuthDetail';
import {Status} from '../../constants/cardByStatus';
import {useAuthorizationsStore} from '../../store/authorizationsStore';

const {
	title,
	password,
	errorState,
	authorizedProcedure,
	authorizedProvider,
	passwordAuthorizedIn,
	validUntil,
	situatedIn,
	instructions,
	infoDescription,
} = translations['pt-br'].privateFlow.requestAuthorizations.detail;

export function RequestDetail() {
	const navigate = useNavigate();
	const location = useLocation();

	const nuControle = location.state && location.state.nuControle;

	const attachSentNotification = useAuthorizationsStore(state => state.attachSentNotification);
	const setAttachSentNotification = useAuthorizationsStore(
		state => state.setAttachSentNotification,
	);
	const {
		data: requestDetail,
		isLoading: loadingRequestDetails,
		isError: requestDetailsHasError,
		refetch: refresh,
	} = useGetAuthDetail(nuControle);
	const {isEnabled: isTrilhaAutorizacaoEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_TRILHA_AUTORIZACAO,
	);

	const requestDetailsHasValue = !!requestDetail;

	const {
		dsSituacao = '',
		nuProtocolo = '',
		dtAutorizacao = '',
		dtValidade = '',
		cdSenha = '',
		nmPrestador = '',
		endereco = '',
		mensagens = [],
		listaArquivos = [],
		procedimento = undefined,
		nuFone = '',
	} = requestDetail || {};

	const mappedStatus = statusMap[dsSituacao] ?? AuthorizationStatusEnum.PENDING;

	const handleBack = useCallback(() => {
		navigate(AuthorizationsEnum.AUTHORIZATIONS_REQUESTS);
	}, []);

	const dtValidadeMessage = dtValidade ? ` ${validUntil} ${dtValidade}` : '';
	const passwordDataMessage = dtAutorizacao
		? `${passwordAuthorizedIn} ${dtAutorizacao}${dtValidadeMessage}.`
		: '';

	const procedureData = procedimento
		? `${authorizedProcedure} ${procedimento?.cdProcedimento} - ${procedimento?.nmProcedimento}.`
		: '';
	const enderecoMessage = endereco ? `${situatedIn} ${endereco}.` : '';
	const phoneMessage = nuFone || '';
	const providerData = nmPrestador
		? `${authorizedProvider} ${nmPrestador}. ${enderecoMessage} ${phoneMessage}.`
		: '';

	const isFinalizedAndHasPassword = mappedStatus === AuthorizationStatusEnum.FINISHED && cdSenha;
	const shouldShowUpload = mappedStatus === AuthorizationStatusEnum.PENDING;

	return (
		<PageWrapperLayout title={title}>
			<MainHeader
				variant="subRoute"
				title={title}
				handleBack={handleBack}
				handleClose={handleBack}>
				{isTrilhaAutorizacaoEnabled ? (
					<AlertInfo.Root severity="info" sx={{borderRadius: '0'}}>
						<AlertInfo.Description>{infoDescription}</AlertInfo.Description>
					</AlertInfo.Root>
				) : null}
				{attachSentNotification ? (
					<DialogFinished
						nuProtocolo={nuProtocolo}
						onClose={() => setAttachSentNotification(false)}
						isAttachment
					/>
				) : null}
			</MainHeader>

			<StyledRootGrid>
				<StyledGridItem sm={12} md={8} lg={8}>
					{requestDetailsHasError ? (
						<ErrorState
							title={errorState.title}
							description={errorState.description}
							handleRefresh={refresh}
						/>
					) : null}

					{loadingRequestDetails ? <LoadingState widthSkeleton={212} p={2} /> : null}

					{requestDetailsHasValue ? (
						<Fragment>
							<RequestInfoDetailCard
								nuControle={nuControle}
								dsSituacao={mappedStatus as Status}
								nuProtocolo={nuProtocolo}
								dtAutorizacao={dtAutorizacao}
							/>

							{isFinalizedAndHasPassword ? (
								<StyledBoxAlertInfo>
									<AlertInfo.Root icon={false}>
										<StyledAlertTitle title={`${password} ${cdSenha}`} />
										<AlertInfo.Description>
											{passwordDataMessage}
											<br />
											{procedureData}
											<br />
											{providerData}

											{providerData ? (
												<Fragment>
													<br />
													<br />
												</Fragment>
											) : null}
											{instructions}
										</AlertInfo.Description>
									</AlertInfo.Root>
								</StyledBoxAlertInfo>
							) : null}

							<Messages messages={mensagens} />

							<StyledStack gap={3}>
								<Attachments
									files={listaArquivos}
									nuControle={nuControle}
									showUpload={shouldShowUpload}
								/>
							</StyledStack>
						</Fragment>
					) : null}
				</StyledGridItem>

				<StyledGrid.Item sm={12} md={4} lg={4}>
					<BeneficiaryCard shouldShowAnsPlanRegister={false} />
				</StyledGrid.Item>
			</StyledRootGrid>

			<StyledFooterContainer>
				<MainFooter />
			</StyledFooterContainer>
		</PageWrapperLayout>
	);
}
